<template>  
  <v-menu offset-y>
    <v-btn small slot="activator" icon :style="{color,backgroundColor}" flat :title="$t('Pilot.MissionDrawer.SelectCustomMissionColorTooltip')" ><v-icon >mdi-palette</v-icon></v-btn>
    <v-list>                
      <v-list-tile v-for="style in $options.stylesList" :key="style.name" 
                  @click="$store.myActions.UI_SET_ITEM_MAP_STYLE({uiid,style,colorType,mapUiid})">
            <v-list-tile-avatar :class="style.name"  size="25" small :color="style.color"></v-list-tile-avatar>      
              <v-list-tile-title>{{$t(`Color.${style.name}`)}}</v-list-tile-title>
      </v-list-tile>
    </v-list>  
  </v-menu>
</template>
<script>  
  import { mapGetters } from 'vuex'  
  import { AloMission } from '@/models/alo/AloMission'      
  import {stylesList, defaultMapStyle} from '@/components/map/MapStyles'  
  export default {
    name: 'MissionColor',    
    props:{
      mission:{
        type: AloMission
      },
      uiid:{
          type: String,
          required: true
      },
      mapUiid:{
        type: String
      },
      colorType:{
        type: String,
        default: 'mission'
      }
    },
    created(){
      this.$options.stylesList = stylesList
      this.$options.defaultMapStyle = defaultMapStyle
    },
    computed:{
      ...mapGetters([
        'uistatebyuiid'        
      ]),       
      missionState() {  
        //retourne un MissionUiState        
        return this.uistatebyuiid(this.uiid)
      },         
      color() {
        let nameColor = this.$options.defaultMapStyle.name
        if(this.missionState && this.missionState.mapStyles && this.missionState.mapStyles.name) {
            nameColor = this.missionState.mapStyles.name
        }        
        //const nameColor = (this.missionState && this.missionState.mapStyles && this.missionState.mapStyles.name)?this.missionState.mapStyles.name:this.$options.defaultMapStyle.name
        return nameColor === 'Default'?'#000000':this.$options.stylesList.find(c => c.name === nameColor).color        
      },
      backgroundColor(){
        return this.color === '#ffffff'?'#000000':'#ffffff'
      }
    },
    methods:{
      
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.White>div{
  border: solid 2px #000!important;
}
</style>
